define('views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
   'views/modules/calendar/animated-session/exercise/weight/weight-header',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-header.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightExerciseHeader,
    // templates
    TWeightEditHeader
) {

    var VWeightEditHeader = VWeightExerciseHeader.extend({
        template: TWeightEditHeader,
    });

    return VWeightEditHeader;

});

